import 'css-chunk:src/feature/payment/CheckPageVoided.module.scss';export default {
  "root": "CheckPageVoided_root",
  "activity_root": "CheckPageVoided_activity_root",
  "activity": "CheckPageVoided_activity"
};